import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import {
  DefaultDiagnosticCollectionSettings,
  DiagnosticCollectionSettings
} from '../servers-grid/shared'

export const diagnosticQuery = gql`
  query DiagnosticQuery($organizationID: String!, $serverID: String!) {
    diagnosticCollection(organizationID: $organizationID, serverID: $serverID) {
      uuid
      enabled
      logLevel
      startTime
      expires
    }
  }
`

interface ChildrenProps {
  readonly loading: boolean
  readonly diagnosticCollectionSettings: DiagnosticCollectionSettings
  readonly refetch: any
}

export function DiagnosticCollectionLoader({
  organizationID,
  serverID,
  children
}: {
  readonly organizationID: string
  readonly serverID: string
  readonly children: (props: ChildrenProps) => React.ReactNode
}) {
  return (
    <Query
      query={diagnosticQuery}
      variables={{ organizationID, serverID }}
      errorPolicy="all"
    >
      {({ data, loading, refetch, ...props }) => {
        if (props.error) {
          throw new Error(props.error)
        }
        let diagnosticCollectionSettings: DiagnosticCollectionSettings =
          data.diagnosticCollection
        if (
          diagnosticCollectionSettings === undefined ||
          isExpired(diagnosticCollectionSettings)
        ) {
          diagnosticCollectionSettings =
            new DefaultDiagnosticCollectionSettings()
        }
        return children({
          loading,
          diagnosticCollectionSettings,
          refetch
        })
      }}
    </Query>
  )
}

// exported for testing
export function isExpired(
  diagnosticCollectionSettings: DiagnosticCollectionSettings
) {
  // if null, then return true because not set yet
  const expiryTime: number = diagnosticCollectionSettings.expires
  if (expiryTime === null) {
    return true
  }
  return new Date().getTime() > expiryTime
}
